<template>
  <div>
    <router-view></router-view>
    <AppAlert :alerts="alertState.alerts" @close="handleCloseAlert" />
  </div>
</template>

<script>
import AppAlert from './components/app/AppAlert.vue';
import { alertService } from './libs/alert';

export default {
  name: 'App',
  data() {
    return {
      alertState: alertService.getState()
    };
  },
  methods: {
    handleCloseAlert(id) {
      alertService.remove(id);
    }
  },
  components: { AppAlert }
}
</script>

<style>

.material-design-icon {
  line-height: 1;
}

.material-design-icon svg {
  display: block;
  pointer-events: none;
}

</style>
